import React from "react";
import ItineraryHubPage from "@/components/ItineraryHubPage";
import { HUB_GRANSUR_OUARZA_FEZ } from "@/lib/itineraryHubs";
export default function GransurOuarzaFezHubPage() {
  return <ItineraryHubPage hub={HUB_GRANSUR_OUARZA_FEZ} />;
}
